import { render, staticRenderFns } from "./cwl.vue?vue&type=template&id=528ec904&scoped=true&"
import script from "./cwl.vue?vue&type=script&lang=js&"
export * from "./cwl.vue?vue&type=script&lang=js&"
import style0 from "./cwl.vue?vue&type=style&index=0&id=528ec904&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528ec904",
  null
  
)

export default component.exports